import React, { useState, useEffect } from "react";
import { useApp } from "context";

import { Carousel as RRC } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import "assets/scss/components/carousel.scss";

// import images statically
import image1 from "assets/images/image1.jpg";
import image2 from "assets/images/image2.jpg";
import image3 from "assets/images/image3.jpg";

type Props = {
  actions: (() => void)[];
};

const images: string[] = [image1, image2, image3];

export const Carousel = (props: Props) => {
  const { theme } = useApp();

  const [isWide, setIsWide] = useState(window.innerWidth > 600);

  useEffect(() => {
    const handleResize = () => setIsWide(window.innerWidth > 600);
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <RRC
      autoPlay
      interval={2000}
      infiniteLoop
      stopOnHover
      swipeable
      showThumbs={false}
      showIndicators
      showStatus
      centerMode={isWide}
      centerSlidePercentage={isWide ? 100 / 3 : undefined}
      onClickItem={(index: number, item: React.ReactNode) =>
        props.actions[index]()
      }
    >
      {images.map((src, index) => (
        <div key={index} style={{ cursor: "pointer" }}>
          <img src={src} alt={`carousel-${index}`} />
        </div>
      ))}
    </RRC>
  );
};
